import { InfoCircleOutlined } from "@ant-design/icons"
import { Typography } from "antd"
import React from "react"

import { LockedFieldCard } from "./FieldCard.tsx"

const { Text, Title } = Typography

interface InheritedFieldsPanelProps {
  fields: { key: string; label: string }[]
}

export function InheritedFieldsPanel({ fields }: InheritedFieldsPanelProps) {
  if (fields.length === 0) return null

  return (
    <div className="rounded-lg border border-blue-100 bg-blue-50/60 p-3">
      <div className="mb-1 flex items-center gap-2">
        <InfoCircleOutlined className="text-blue-500" />
        <Title className="m-0 text-sm" level={5}>
          Already required (inherited from previous stages)
        </Title>
      </div>
      <Text className="mb-2 block text-xs" type="secondary">
        These fields are required from earlier stages and cannot be removed
        here.
      </Text>
      <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
        {fields.map((field) => (
          <LockedFieldCard
            fieldKey={field.key}
            key={field.key}
            label={field.label}
          />
        ))}
      </div>
    </div>
  )
}
